<template>
	<i class="w-8 h-8 flex items-center justify-center">
		<svg
			width="18"
			height="12"
			viewBox="0 0 18 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M17.1429 3.15885L11.299 0.000129368L11.2903 0.014293L11.2642 0.000129367L6.2177 8.22755L6.92522 8.61204L9.32018 4.7075L14.4709 7.49159L17.1429 3.15885Z"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M-0.000276906 3.15885L5.84355 0.000129246L5.85229 0.014293L5.87835 0.000129246L10.9249 8.22755L10.2174 8.61204L7.8224 4.7075L2.67167 7.49159L-0.000276906 3.15885Z"
				fill="white"
			/>
		</svg>
	</i>
</template>